import WebLayout from "../../components/webLayout/WebLayout";
import FeedBackForm from "./FeedBackForm/FeedBackForm";

const FeedBack = () => {
  return (
    <WebLayout>
      <FeedBackForm />
    </WebLayout>
  );
};

export default FeedBack;
